/**
 * Single source of truth for the Messziele shown under a selected Hebel, shared by every cockpit
 * (trainer + Mein-Bereich) so the set can never drift between them. Reached measurements
 * (targetValue === null) are kept, not filtered out — they render as done — so a selected Hebel
 * always shows its measurements.
 *
 * Scoping compares the lever against `healthCategory` (kraft, beweglichkeit, …) — `categoryKey`
 * is the measurement key (kniebeuge, balance, …) and never matches a lever, which is exactly the
 * bug that made Messziele disappear entirely. Report snapshots generated before healthCategory
 * existed cannot be scoped; for those the worst three overall are shown instead of nothing, until
 * the report is regenerated.
 */
export function selectMeasurementTargets(targets, leverCategory) {
    if (leverCategory === null) {
        return [];
    }
    const scopable = targets.every(target => target.healthCategory != null);
    const selected = scopable
        ? targets.filter(target => target.healthCategory === leverCategory)
        : [...targets];
    return selected
        .sort((a, b) => a.currentScore - b.currentScore)
        .slice(0, 3);
}
